import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { platformEntity, entityAction } from '~constants/index';
import showElementByAuth from '~helpers/auth';
import NewFilters from 'common/components/filters';
import Search from 'common/components/search';
import { useGetCountries, DISPLAY_ALL_FILTER, OWNED_BY_ME_FILTER } from '../useLandlords';

const useStyles = makeStyles(
  theme => ({
    header: {
      ...theme.flex.mainSpaceBetween,
      minHeight: 40,
      marginTop: 24,
      marginBottom: 24,
    },
    leftWrapper: {
      ...theme.flex.fill,
    },
    count: {
      ...theme.typography.h1,
      fontSize: 22,
      color: theme.colors.titleColor,
      marginRight: 20,
    },
    filters: {
      ...theme.flex.mainStart,
      ...theme.flex.crossCenter,
    },
    addButton: {
      fontSize: 14,
      fontWeight: 'bold',
    },
  }),
  { name: 'landlordManagement' },
);

const Header = ({ landlords, accountManager, setFilters, handleShowModal, billingCountries }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { countriesData, loading } = useGetCountries();
  const handleCountryChange = value => {
    setFilters({
      pageNumber: 1,
      billingCountryIds: value,
    });
  };

  const handleAccountChange = value => {
    setFilters({
      pageNumber: 1,
      accountManager: value,
    });
  };

  return (
    <div className={classes.header}>
      <div className={classes.leftWrapper}>
        <div className={classes.count}>
          {t('cms.landlord.count', {
            number: landlords.total,
          })}
        </div>

        <div className={classes.filters}>
          {!loading && (
            <Search
              placeholder={t(
                'cms.property_status_filter.countries_filter.title.filter_your_country',
              )}
              selectType={'text'}
              optionLists={countriesData}
              onSearch={handleCountryChange}
              submitType={'value'}
              defaultChecked={billingCountries}
            />
          )}

          <NewFilters
            options={[
              { text: t('cms.landlords.filters_account_all'), value: DISPLAY_ALL_FILTER },
              { text: t('cms.landlords.filters_account_by_me'), value: OWNED_BY_ME_FILTER },
            ]}
            value={accountManager}
            placeholder={t('cms.landlords.filters_account_title')}
            onChange={handleAccountChange}
          />
        </div>
      </div>
      <If condition={showElementByAuth(platformEntity.LANDLORDS_LANDLORDS, entityAction.CREATE)}>
        <Button className={classes.addButton} type="primary" size="large" onClick={handleShowModal}>
          {t('cms.landlord.add_new_landlord.button')}
        </Button>
      </If>
    </div>
  );
};

Header.propTypes = {
  landlords: PropTypes.shape({
    total: PropTypes.number,
  }),
  currentTab: PropTypes.number,
  accountManager: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  handleShowModal: PropTypes.func.isRequired,
  billingCountries: PropTypes.array,
};

export default memo(Header);
